import AnalyticsService, { EventNameAMP } from 'application/services/AnalyticsService';
import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { toast } from '@shared/ui';

import { IS_NEED_SHOW_LICENSES_MODAL } from './licensesModalStorageKeys';

export const redirectToBindCard = (link: string | undefined) => {
  AnalyticsService.event(EventNameAMP.BIND_CARD_PRESSED);

  if (link) {
    window.location.assign(link);
  } else {
    toast.error(TEXTS.BILLING_BIND_CARD_NOTIFICATION_ERROR_MESSAGE);

    localStorage.removeItem(IS_NEED_SHOW_LICENSES_MODAL);
  }
};
